import { Loader, SearchInput } from "@tfg/ui"
import { noop } from "lodash"

type SearchBarProps<T> = {
  filtersValue: T & { search?: string }
  setFiltersValue: (filters: T) => void
  placeholder: string
  isFetching: boolean
}

export const SearchBar = <T,>({
  filtersValue,
  setFiltersValue,
  placeholder,
  isFetching,
}: SearchBarProps<T>) => {
  const handleSearchChange = (value: string | number): void => {
    setFiltersValue({
      ...filtersValue,
      search: value.toString(),
    } as T)
  }

  return (
    <SearchInput
      inputValue={filtersValue?.search ?? ""}
      onOpen={noop}
      delay={600}
      autoFocus
      w={180}
      placeholder={placeholder}
      onChange={handleSearchChange}
      rightSection={isFetching && <Loader size={16} />}
    />
  )
}
